export default {
  "REMEMBER_ME": "记住我",
  "LOGIN": "登录",
  "LOGOUT": "登出",
  "APPLY": "应用",
  "SUGGEST_BROWSER": "建议浏览器",
  "SUGGEST_RESOLUTION": "建议最低分辨率",
  "INVALID_ACCESS": "抱歉，您无权访问",
  "PERSONAL_CENTER": "个人中心",
  "UPDATE_PASSWORD": "修改密码",
  "ADD": "新增",
  "EDIT": "编辑",
  "CONFIRM": "确定",
  "SELECT": "选择",
  "RESET": "重置",
  "CANCEL": "取消",
  "CLOSE": "关闭",
  "EXIT": "退出",
  "ALL": "全部",
  "STATUS": "状态",
  "SEARCH": "查询",
  "ACTION": "操作",
  "DELETE": "删除",
  "PROMPT": "提示",
  "RESET_PASSWORD": "重置密码",
  "ENABLE": "启用中",
  "DISABLE": "禁用中",
  "USE": "启用",
  "BAN": "禁用",
  "BASE_INFO": "基本信息",
  "USERNAME": {
    "label": "账户名",
    "required": "请输入 账户名",
    "placeholder": "必填，长度 3 - 20",
    "length": "账户名 长度 3 - 20",
    "noSpace": "账户名 不允许有空格"
  },
  "OLD_PASSWORD": {
    "label": "旧密码",
    "placeholder": "必填，长度 8 - 30",
    "required": "请输入 旧密码",
    "length": "旧密码 长度 8 - 30"
  },
  "NEW_PASSWORD": {
    "label": "新密码",
    "placeholder": "必填，长度 8 - 30",
    "required": "请输入 新密码",
    "length": "新密码 长度 8 - 30"
  },
  "CONFIRM_NEW_PASSWORD": {
    "label": "确认密码",
    "placeholder": "必填，与新密码一致",
    "required": "请输入 确认密码",
    "identical": "两次密码输入不一致"
  },
  "PASSWORD": {
    "label": "密码",
    "placeholder": "必填, 请输入密码",
    "required": "请输入 密码",
    "length": "密码 长度 8 - 30"
  },
  "SLIDER": {
    "required": "请拖动 滑块"
  },
  "CONFIRM_PASSWORD": {
    "label": "确认密码",
    "placeholder": "必填，与密码一致",
    "required": "请输入 确认密码",
    "identical": "两次密码输入不一致"
  },
  "ROLE": {
    "label": "角色"
  },
  "ROLE_NAME": {
    "label": "角色名",
    "placeholder": "必填，长度 3 - 15",
    "required": "请输入 角色名",
    "length": "角色名 长度 3 - 15",
    "noSpace": "角色名 不允许有空格"
  },
  "ROLE_DESC": {
    "label": "描述",
    "placeholder": "非必填，长度 0 - 50",
    "length": "描述 长度 0 - 50"
  },
  "PERMISSION": {
    "label": "权限"
  },
  "ORG": {
    "label": "组织机构"
  },
  "ORG_NAME": {
    "label": "组织机构名",
    "placeholder": "必填，长度 2 - 15",
    "required": "请输入 组织机构名",
    "length": "组织机构名 长度 2 - 15"
  },
  "ORG_PARENT": {
    "label": "所属组织机构"
  },
  "RESOURCE_NAME": {
    "label": "资源名称",
    "placeholder": "必填",
    "required": "请输入 资源名称"
  },
  "RESOURCE_URI": {
    "label": "资源标识",
    "placeholder": "必填",
    "required": "请输入 资源标识"
  },
  "JOB_NUMBER": {
    "label": "工号",
    "required": "请输入 工号",
    "placeholder": "必填，长度 2 - 14",
    "length": "工号 长度 2 - 14",
    "length2": "工号 长度 2 - 18",
    "placeholder2": "必填，长度 2 - 18"
  },
  "EMAIL": {
    "label": "邮箱",
    "placeholder": "请输入正确的邮箱格式",
    "required": "请输入 邮箱",
    "email": "请输入正确的 邮箱格式"
  },
  "NAME": {
    "label": "姓名",
    "placeholder": "必填，长度 2 - 14",
    "length": "姓名 长度 2 - 14"
  },
  "MOBILE": {
    "label": "手机号",
    "placeholder": "必填，正确的11位手机号格式",
    "mobile": "请输入正确的 手机号格式",
    "required": "请输入 手机号"
  },
  "EVENT": {
    "id": "事件id",
    "id_placeholder": "必填 长度 2 - 40",
    "id_length": "事件id 长度 2 - 40",
    "id_required": "请输入 事件id",
    "name": "事件名",
    "name_placeholder": "必填 长度 2 - 40",
    "name_length": "事件名 长度 2 - 40",
    "name_required": "请输入 事件名",
    "description": "事件说明",
    "description_placeholder": "必填 长度 2 - 50",
    "description_length": "事件说明 长度 2 - 50",
    "description_required": "请输入 事件说明",
    "count": "数量"
  },
  "success": {
    "ADD": "新增成功",
    "DELETE": "删除成功",
    "EDIT": "编辑成功",
    "OPERATE": "操作成功",
    "SEND": "发送成功",
    "UPDATE_PASSWORD": "修改密码成功，3秒后返回登录界面",
    "REALTE": "关联成功  ",
    "ADD2": "新增成功  ",
    "EDIT2": "编辑成功  ",
    "OPERATE2": "操作成功  ",
    "SAVE2": "保存成功  ",
    "HANDLE2": "处理成功  ",
    "RESTART2": "重启成功  ",
    "UNBIND": "解绑成功",
    "UNREALTE": "取消关联成功"
  },
  "error": {
    "ADD": "新增失败，",
    "DELETE": "删除失败，",
    "EDIT": "编辑失败，",
    "OPERATE": "操作失败，",
    "SEND": "发送失败",
    "LOGIN_EXPIRED": "登录超时，请重新登录",
    "10001": "用户名或密码错误",
    "10002": "该账户已被禁用",
    "10003": "账户名已存在",
    "10004": "不允许删除自己",
    "10005": "不允许修改自己状态",
    "10006": "旧密码错误",
    "10010": "角色名已存在",
    "10011": "该角色已被账户使用",
    "10020": "组织机构名已存在",
    "10021": "该组织机构已被账户使用",
    "10022": "该组织机构已有子组织机构",
    "10023": "该组织机构已被角色使用",
    "10030": "该账号无该权限",
    "10040": "权限URI已存在",
    "10041": "该权限已被角色使用",
    "10042": "该权限已有子权限",
    "10050": "栏目名已存在",
    "10051": "该栏目已被文章使用",
    "10052": "该栏目已有子栏目",
    "10053": "无该栏目",
    "10060": "广告位编号已存在",
    "10061": "该广告位已被广告使用",
    "10062": "无该广告位",
    "10063": "该广告位已被禁用",
    "10070": "版本号已存在",
    "118100": "关键字类型无效",
    "118101": "关键字无效",
    "118102": "车辆标签不存在",
    "118103": "车辆不存在",
    "118104": "关键字类型为空",
    "118105": "车辆不存在",
    "118106": "插入数据库失败",
    "118107": "品牌名已存在",
    "118108": "品牌代码已存在",
    "118109": "品牌未找到",
    "118110": "该品牌无法删除",
    "118111": "车系名已存在",
    "118112": "车系代码已存在",
    "118113": "车系不存在",
    "118114": "车型名已存在",
    "118115": "车型代码已存在",
    "118116": "车型未找到",
    "118117": "该车系无法删除",
    "118118": "该车型无法删除",
    "118119": "车身颜色名已存在",
    "118120": "车身颜色代码已存在",
    "118121": "车身颜色未找到",
    "118122": "VIN码已存在",
    "118123": "电信运营商未找到",
    "118124": "电信运营商名已存在",
    "118125": "ICCID已存在",
    "118126": "SIM卡未找到",
    "118127": "设备供应商未找到",
    "118128": "设备类型未找到",
    "118129": "设备IMEI已存在",
    "118130": "设备未找到",
    "118131": "经销商代码已存在",
    "118132": "经销商不存在",
    "118133": "父级经销商不存在",
    "118134": "父级经销商不能是自己",
    "REALTE": "关联失败  ",
    "ADD2": "新增失败  ",
    "EDIT2": "编辑失败  ",
    "OPERATE2": "操作失败  ",
    "SAVE2": "保存失败  ",
    "HANDLE2": "处理失败  ",
    "RESTART2": "重启失败  ",
    "UNBIND": "解绑失败",
    "UNREALTE": "取消关联失败"
  },
  "prompt": {
    "CANCEL": "确认要取消吗",
    "DELETE": "确认要删除吗",
    "SEND": "确认要发送吗",
    "UNBIND": "确定要解绑吗",
    "UNREALTE": "确定要取消关联吗"
  },
  "warning": {
    "CANNOT_OPERATE_SELF": "不允许操作自己"
  },
  "KEYWORD": "关键字",
  "BRAND": {
    "label": "品牌",
    "required": "请选择 品牌"
  },
  "BRAND_NAME": {
    "label": "品牌名称",
    "placeholder": "必填，长度 1 - 10",
    "required": "请输入 品牌名称",
    "length": "品牌名称 长度 1 - 10"
  },
  "BRAND_NAME_ALIAS": {
    "label": "别名",
    "length": "别名 长度 1 - 20"
  },
  "BRAND_CODE": {
    "label": "品牌代码",
    "placeholder": "必填，长度 1 - 10",
    "required": "请输入 品牌代码",
    "length": "品牌代码 长度 1 - 10"
  },
  "BRAND_COMMENT": {
    "label": "备注",
    "length": "备注 长度 1 - 40"
  },
  "SERIES": {
    "label": "车系",
    "required": "请选择 车系"
  },
  "SERIES_NAME": {
    "label": "车系名称",
    "placeholder": "必填，长度 1 - 10",
    "required": "请输入 车系名称",
    "length": "车系名称 长度 1 - 10"
  },
  "SERIES_NAME_ALIAS": {
    "label": "别名",
    "length": "别名 长度 1 - 20"
  },
  "SERIES_CODE": {
    "label": "车系代码",
    "placeholder": "必填，长度 1 - 10",
    "required": "请输入 车系代码",
    "length": "车系代码 长度 1 - 10"
  },
  "SERIES_COMMENT": {
    "label": "备注",
    "length": "备注 长度 1 - 40"
  },
  "MODEL": {
    "label": "车型",
    "required": "请选择 车型"
  },
  "MODEL_NAME": {
    "label": "车型名称",
    "placeholder": "必填，长度 1 - 10",
    "required": "请输入 车型名称",
    "length": "车型名称 长度 1 - 10"
  },
  "MODEL_NAME_ALIAS": {
    "label": "别名",
    "length": "别名 长度 1 - 20"
  },
  "MODEL_CODE": {
    "label": "车型代码",
    "placeholder": "必填，长度 1 - 10",
    "required": "请输入 车型代码",
    "length": "车型代码 长度 1 - 10"
  },
  "PUBLISH_TIME": "发布时间",
  "MODEL_COMMENT": {
    "label": "备注",
    "length": "备注 长度 1 - 40"
  },
  "COLOR": "颜色",
  "COLOR_NAME": {
    "label": "颜色名称",
    "placeholder": "必填，长度 1 - 10",
    "required": "请输入 颜色名称",
    "length": "颜色名称 长度 1 - 10"
  },
  "COLOR_CODE": {
    "label": "颜色代码",
    "placeholder": "必填，长度 1 - 10",
    "required": "请输入 颜色代码",
    "length": "颜色代码 长度 1 - 10"
  },
  "COLOR_COMMENT": {
    "label": "备注",
    "length": "备注 长度 1 - 40"
  },
  "VIN": {
    "placeholder": "必填，长度 17",
    "label": "VIN",
    "required": "请输入 VIN",
    "length": "VIN 长度 17"
  },
  "LICENSE_PLATE": {
    "label": "车牌号",
    "length": "车牌号 长度 1 - 9"
  },
  "DEVICE_SN": "设备编号",
  "VEHICLE_STATUS": "状态",
  "ENGINE_NUMBER": {
    "label": "引擎编号",
    "length": "引擎编号 长度 1 - 20"
  },
  "MANUFACTURE_TIME": "出厂时间",
  "OFFLINE_TIME": "下线时间",
  "MANUFACTURE": "设备供应商",
  "MANUFACTURE_NAME": {
    "label": "供应商名称",
    "placeholder": "必填，长度 1 - 10",
    "required": "请输入 供应商名称",
    "length": "供应商代名称 长度 1 - 10"
  },
  "MANUFACTURE_NAME_ALIAS": {
    "label": "供应商别名",
    "length": "供应商别名 长度 1 - 10"
  },
  "MANUFACTURE_COMMENT": {
    "label": "备注",
    "length": "备注 长度 1 - 40"
  },
  "TYPE": {
    "label": "设备类型",
    "required": "请选择 设备类型"
  },
  "TYPE_NAME": {
    "label": "类型名称",
    "placeholder": "必填，长度 1 - 10",
    "required": "请输入 类型名称",
    "length": "类型名称 长度 1 - 10"
  },
  "TYPE_NAME_ALIAS": {
    "label": "别名",
    "length": "别名 长度 1 - 20"
  },
  "TYPE_COMMENT": {
    "label": "备注",
    "length": "备注 长度 1 - 40"
  },
  "SN": {
    "label": "SN",
    "required": "请输入 SN",
    "placeholder": "必填"
  },
  "IMEI": {
    "label": "IMEI",
    "required": "请输入 IMEI",
    "length": "IMEI 长度 15",
    "number": "IMEI 为 纯数字",
    "placeholder": "必填, 长度为 15 的纯数字"
  },
  "DEVICE_STATUS": "设备状态",
  "DEVICE_COMMENT": {
    "label": "备注",
    "length": "备注 长度 1 - 40"
  },
  "EXPORT": "导出",
  "ICCID": {
    "label": "ICCID",
    "required": "请输入 ICCID",
    "length": "ICCID 长度 20",
    "number": "ICCID 为 纯数字",
    "placeholder": "必填, 长度为 20 的纯数字"
  },
  "IMSI": {
    "label": "IMSI",
    "required": "请输入 IMSI",
    "length": "IMSI 长度 2 - 15",
    "number": "IMSI 为 纯数字",
    "placeholder": "必填, 长度为 2 - 15 的纯数字"
  },
  "SIM_STATUS": "SIM卡状态",
  "NUMBER": {
    "label": "手机号",
    "required": "请输入 手机号",
    "mobile": "请输入正确的 手机号格式"
  },
  "CARRIER": {
    "label": "运营商",
    "required": "请选择 运营商"
  },
  "ACTIVE_DATE": "激活时间",
  "DEALER_NAME": {
    "label": "经销商名称",
    "placeholder": "必填，长度 1 - 10",
    "required": "请输入 经销商名称",
    "length": "经销商名称 长度 1 - 10"
  },
  "DEALER_CODE": {
    "label": "经销商代码",
    "placeholder": "必填，长度 1 - 10",
    "required": "请输入 经销商代码",
    "length": "经销商代码 长度 1 - 10"
  },
  "PROVINCE": "省",
  "CITY": "市",
  "DISTRICT": "区",
  "ADDRESS": "详细地址",
  "DEALER_PARENT": "父级经销商",
  "CONTACT_NAME": "联系人",
  "CONTACT_PHONE": "联系人电话",
  "AFTER_SALES_CODE": "售后服务电话",
  "RESCUE_PHONE": "救援电话",
  "SALE_PHONE": "销售电话",
  "DEALER_REMARK": {
    "label": "备注",
    "length": "备注  长度 1 - 40"
  },
  "OPEN_TIME": "开业时间",
  "LONGITUDE": "经度",
  "LATITUDE": "纬度",
  "PARENT_GROUP": "父级分组",
  "GROUP_NAME": {
    "label": "分组名称",
    "placeholder": "分组名称 必填",
    "required": "请输入 分组名称"
  },
  "SIMULATOR_TYPE": {
    "label": "模拟器类型",
    "placeholder": "模拟器类型 必选",
    "required": "请选择 模拟器类型"
  },
  "SIMULATOR_NAME": {
    "label": "模拟器名称",
    "placeholder": "模拟器名称 必填",
    "required": "请输入 模拟器名称"
  },
  "GROUP": "分组",
  "OWNER_CENTER": {
    "OWNER_NAME": "车主名称",
    "CAR_VIN": "车辆VIN码",
    "ID": "证件号",
    "BEAN_ID": "beanId",
    "CLIENT_TYPE": "客户类型",
    "ENTERPRISE_TYPE": "企业类型",
    "ENTERPRISE_CODE": "企业统一社会代码",
    "CERTIGICATE_TYPE": "证件类型",
    "ENTERPRISE_NAME": "企业名称",
    "CHANGE_TYPE": "变更类型",
    "CHANGE_CAUSE": "变更原因",
    "CHANGE_TIME": "变更时间",
    "CREATE_TIME": "创建时间",
    "UPDATE_TIME": "更新时间",
    "OWNER_CAR_NUM": "拥有车辆数",
    "CREATE_FROM": "创建来源",
    "VIN_placeholder": "请输入车辆VIN码",
    "NAME_placeholder": "请输入姓名",
    "ID_placeholder": "请输入证件号",
    "CLIENT_TYPE_placeholder": "请选择客户类型",
    "ENTERPRISE_TYPE_placeholder": "请输入企业类型",
    "ENTERPRISE_CODE_placeholder": "请输入企业统一社会代码",
    "OWNER_NAME_placeholder": "请输入车主名称",
    "TYPE_placeholder": "请选择状态",
    "CREATE_TIME_placeholder": "请选择开始时间 - 结束时间",
    "BEAN_ID_placeholder": "请输入beanId"
  },
  "menu": {
    "": "",
    "/": "TSP运营管理平台",
    "/basic": "基础信息管理",
    "/basic/vehicleBasic": "车型基础信息管理",
    "/basic/vehicle": "车辆信息管理",
    "/basic/deviceBasic": "设备基础信息管理",
    "/basic/device": "设备信息管理",
    "/basic/deviceChange": "设备更换管理",
    "/basic/sim": "SIM卡信息管理",
    "/basic/dealer": "经销商信息管理",
    "/basic/blueTooth": "蓝牙钥匙信息管理",
    "/basic/battery": "电池信息管理",
    "/basic/maintenance": "维保预值管理",
    "/basic/carDataBnormal": "车辆数据异常信息",
    "/customer": "客户数据管理",
    "/customer/user": "用户管理",
    "/customer/newuser": "新用户管理",
    "/customer/userbindingquery": "用户车辆绑定查询",
    "/customer/carboundchange": "车辆绑定变更记录",
    "/customer/owner": "车主管理",
    "/customer/sale": "销售数据管理",
    "/customer/saleDataBnormal": "销售数据异常信息",
    "/customer/blueToothUser": "蓝牙用户管理",
    "/monitor": "车辆监控管理",
    "/monitor/screen": "大屏监控",
    "/monitor/status": "车辆状况",
    "/monitor/position": "监控定位",
    "/monitor/playback": "轨迹回放",
    "/monitor/travel": "行程管理",
    "/monitor/malfunction": "报警管理",
    "/monitor/notice": "报警通知管理",
    "/monitor/online": "在线时长管理",
    "/monitor/charge": "充电记录管理",
    "/monitor/singleDaily": "单车日报表",
    "/message": "消息中心",
    "/message/create": "群发消息",
    "/message/list": "车机发送列表",
    "/message/applist": "APP发送列表",
    "/message/manage": "消息设置",
    "/content": "内容管理",
    "/content/column": "栏目管理",
    "/content/article": "文章管理",
    "/content/advert": "广告管理",
    "/content/feedback": "意见反馈",
    "/content/UserProtocolManagement": "用户协议管理",
    "/content/category": "前端类目管理",
    "/configCenter": "配置中心",
    "/configCenter/buriedConfig": "车机埋点配置",
    "/configCenter/userConfig": "车机用户配置",
    "/configCenter/vehicleConfig": "车机车辆配置",
    "/configCenter/sysConfig": "车机系统配置",
    "/shop": "在线商城",
    "/shop/goods": "商品管理",
    "/shop/order": "商品订单",
    "/report": "电池信息上报",
    "/report/prod": "生产数据上报",
    "/report/sale": "销售数据上报",
    "/report/fix": "维修数据上报",
    "/vehicleSetting": "车辆设置",
    "/vehicleSetting/terminal": "终端参数设置",
    "/vehicleSetting/remote": "车辆远程设置",
    "/simulator": "TBox模拟器",
    "/systemConfig": "系统配置",
    "/systemConfig/application": "应用管理",
    "/systemConfig/version": "升级管理",
    "/systemConfig/config": "参数配置",
    "/systemConfig/resful": "运营卡片管理",
    "/system": "系统管理",
    "/system/resource": "权限管理",
    "/system/admin": "账户管理",
    "/system/role": "角色管理",
    "/system/org": "组织机构管理",
    "/subsystem": "产线检测系统管理",
    "/subsystem/admin": "账户管理",
    "/subsystem/role": "角色管理",
    "/subsystem/org": "组织机构管理",
    "/dealersystem": "经销商系统管理",
    "/dealersystem/admin": "账户管理",
    "/dealersystem/role": "角色管理",
    "/dealersystem/org": "组织机构管理",
    "/systemMessage": "站内消息",
    "/systemMessage/received": "接收的消息",
    "/systemMessage/sent": "发送的消息",
    "/evgb": "数据追踪",
    "/evgb/historyData": "历史数据",
    "/evgb/traceData": "数据追踪",
    "/evgb/receiveForwardStatistic": "数据接收转发统计",
    "/evgb/singleVehicleStatistic": "单车数据统计",
    "/compliance": "符合性检测",
    "/compliance/complianceRate": "车辆合规率查询",
    "/compliance/statisticalTask": "统计任务",
    "/behavior": "用户行为",
    "/behavior/realtime": "实时行为",
    "/behavior/event": "事件管理",
    "/behavior/analyze": "事件分析",
    "/behavior/board": "看板",
    "/gateway": "网关协议配置",
    "/gateway/diction": "字典维护",
    "/gateway/signal": "信号维护",
    "/gateway/configFile": "配置文件维护",
    "/payment": "支付模块",
    "/payment/Management": "支付功能管理",
    "/payment/account": "商户账户管理",
    "/payment/channel": "渠道管理",
    "/payment/financial": "财务管理",
    "/themeStore": "车机主题管理",
    "/themeStore/classify": "主题分类管理",
    "/themeStore/management": "主题管理",
    "/themeStore/recomend": "推荐主题",
    "/equipmentReplace": "设备更换管理",
    "/equipmentReplace/TBOXReplace": "TBOX更换",
    "/equipmentReplace/HUReplace": "HU更换",
    "/equipmentReplace/AIOReplace": "一体机更换",
    "/equipmentReplace/blueToothReplace": "蓝牙模块更换",
    "/logManagement": "车辆调试管理",
    "/logManagement/HULogControl": "HU日志管理",
    "/logManagement/vehicleDebug": "车况解析调试工具",
    "/logManagement/remoteControl": "远程控制调试工具",
    "/logManagement/offLineVehMonitoring": "长期未上线车辆监控",
    "/logManagement/bikeRemoteFull": "单车远程失败控制全链路可视化监控",
    "/logManagement/wakeRing": "唤醒功能",
    "/logManagement/TBOXLogControl": "T3/T4日志管理",
    "/logManagement/LogManage": "T5-Tbox日志管理",
    "/logManagement/internationParameters": "国际参数查询",
    "/servicePackage": "服务套餐管理",
    "/servicePackage/basicInfo": "套餐基础信息管理",
    "/servicePackage/basicService": "基础服务管理",
    "/servicePackage/picService": "服务套餐图片设置",
    "/statement": "报表管理",
    "/statement/basicStatistics": "基础数据新增统计",
    "/statement/IOVStatistics": "车联网开通统计",
    "/statement/messageStatistics": "消息中心阅读统计",
    "/statement/APPuserBehavior": "APP用户行为统计",
    "/refuelingService": "加油服务管理",
    "/refuelingService/serviceProvider": "服务商管理",
    "/refuelingService/gasStationConfig": "加油站配置",
    "/refuelingService/refuelingOrder": "在线加油订单",
    "/refuelingService/dataReport": "数据报表",
    "/refuelingService/storeManagement": "门店管理",
    "/diagnostic": "诊断模型配制管理",
    "/diagnostic/solution": "诊断模型方案配制",
    "/content/channelPage": "频道页面配置管理",
    "/content/messageContent": "内容信息管理",
    "/content/mark": "标签管理",
    "/content/thirdParty": "后端类目管理",
    "/content/audioDiv": "音频管理",
    "/content/album": "音频专辑管理",
    "/content/figure": "音频人物管理",
    "/content/staticConfig": "静态内容配置管理",
    "/content/bussinessType": "业务类型配置管理",
    "/content/orientationScheme": "内容定向配置管理",
    "/content/customClassification": "自定义分类配置管理",
    "/content/serviceRules": "动态内容规则管理",
    "/merchants": "商家管理",
    "/merchants/resourceSupplier": "商家信息管理",
    "/merchants/strategyConfiguration": "策略配置管理",
    "/merchants/payConfiguration": "商家支付配置",
    "/merchants/typeConfiguration": "商家类型配置",
    "/merchants/businessConfiguration": "商家业务类型配置",
    "/callCenterSupport": "呼叫中心支撑",
    "/callCenterSupport/callUsage": "呼叫中心使用情况",
    "/vehicleOwnerCentrical": "车主中心",
    "/vehicleOwnerCentrical/ownerManagement": "车主管理",
    "/vehicleOwnerCentrical/bindOwnerVhicle": "车主车辆绑定查询",
    "/vehicleOwnerCentrical/bindChange": "车辆绑定变更记录",
    "/buxManagement": "BUX运营管理",
    "/buxManagement/cCarVoicePrint": "车机声纹管理",
    "/order": "订单中心",
    "/order/orderCenter": "订单管理",
    "/order/orderCenter/orderDetail": "订单详情",
    "/order/refundOrder": "退款订单",
    "/order/refundOrder/refundDetail": "退款详情",
    "/order/refundOrder/refundSHDetail": "退款审核详情",
    "/middlePlatform/rightspack": "线索管理中心",
    "/middlePlatform/rightspack/aviInsurance": "航意险",
    "/middlePlatform/rightspack/rescue": "救援",
    "/recommend": "推荐策略管理",
    "/recommend/userGroup": "用户分群",
    "/recommend/recommendAttributes": "推荐属性配置",
    "/recommend/operations": "运营策略管理",
    "/recommend/recommendEntrance": "推荐入口管理",
    "/platform": "平台管理",
    "/platform/shop": "商城管理",
    "/platform/goods": "商品管理",
    "/platform/category": "类目管理",
    "/platform/specifications": "规格管理 ",
    "/platform/attribute": "属性管理",
    "/platform/brand": "品牌管理",
    "/shopStore": "商城管理",
    "/shopStore/commodityManagement": "商品管理",
    "/shopStore/storeList": "店铺列表",
    "/shopStore/storeClassification": "店铺分类",
    "/storeManagement": "店铺管理",
    "/storeManagement/goods": "商品管理",
    "/storeManagement/classification": "商品分类",
    "/storeManagement/category": "类目管理",
    "/storeManagement/frontMarketClassify": "前台营销分类",
    "/storeManagement/specifications": "规格管理",
    "/storeManagement/attribute": "属性管理",
    "/storeManagement/shopLabelManage": "商品标签管理",
    "/storeManagement/logisticsTemplate": "物流模板管理",
    "/storeManagement/preStock": "库存预警商品",
    "/storeManagement/editReport": "商品编辑记录",
    "/storeManagement/batchPrice": "批量定价",
    "/outlet": "门店管理",
    "/outlet/outletList": "门店列表",
    "/outlet/combined": "门店合并",
    "/card": "卡券管理",
    "/card/temp": "卡券模板管理",
    "/card/basic": "卡券基础管理",
    "/card/config": "券包配置管理",
    "/card/configAlloc": "券包分配管理",
    "/card/alloc": "卡券分配管理",
    "/card/drop": "卡券直塞管理",
    "/card/dropFail": "卡券直塞失败结果",
    "/card/cardDetail": "卡券详情管理",
    "/card/cardType": "卡券类型配置",
    "/search": "搜索策略配置",
    "/search/interposeStrategySetting": "干预策略配置",
    "/search/searchWordSetting": "搜索词类型",
    "/search/exogenousWeight": "外源权重设置",
    "/search/recallResNumSetting": "召回结果数量配置",
    "/search/lodingNumSetting": "每页加载数量配置(座舱)",
    "/search/moduleSeqSetting": "模块顺序配置(座舱)",
    "/search/searchEntryQuery": "搜索入口管理",
    "/groupPurchase": "拼团活动",
    "/groupPurchase/activityManagement": "拼团活动管理",
    "/groupPurchase/orderList": "拼团订单列表",
    "/secondKill": "秒杀活动",
    "/secondKill/orderList": "秒杀订单列表",
    "/secondKill/configure": "秒杀活动控制",
    "/secondKill/control": "秒杀控制",
    "/appSearch": "App搜索策略配置",
    "/appSearch/appInterposeStrategySetting": "干预策略配置",
    "/appSearch/appSearchWordSetting": "搜索词类型",
    "/appSearch/appLodingNumSetting": "每页加载数量配置(App)",
    "/appSearch/appModuleSeqSetting": "模块顺序配置(App)",
    "/appSearch/appSearchEntryQuery": "搜索入口管理",
    "/insurancesManagement": "场景险管理",
    "/insurancesManagement/insurancesConfig": "场景险配置管理",
    "/insurancesManagement/insurancesManage": "场景险用户管理",
    "/insurancesManagement/insurancesWisdomOil": "智慧加油",
    "/insurancesManagement/insurancesWisdomOil/deveReformCom": "发改委油价涨跌配置",
    "/carcloud": "云展厅管理",
    "/carcloud/livelist": "直播列表",
    "/carcloud/cluelist": "线索列表",
    "carcloud/roadService":"道路救援券码管理",
    "/instrument": "工具",
    "/instrument/calendar": "日历",
    "/instrument/photoTransformLink": "图片转H5链接",
    "/community": "社区管理",
    "/integrating": "积分中心",
    "/integrating/sceneConfig": "积分场景配置",
    "/integrating/portMaintenance": "端口号码维护",
    "/activity": "活动中心",
    "/activity/actManager": "活动管理",
    "/activity/actThemManager": "活动专题管理",
    "/activity/actDataManager": "活动数据",
    "/activity/actLeaveMessage": "活动留言",
    "/activity/atlasManager": "活动图集",
    "/activity/carFriendManager": "车友会活动",
    "/activity/distributorManager": "经销商活动",
    "/activity/actManagerAgent": "活动管理",
    "/activity/actManagerReport": "活动举报",
    "/middleActivity": "活动管理中心",
    "/middleActivity/middleManager": "活动管理",
    "/community/post_management": "帖子管理",
    "/community/topic_management": "话题管理",
    "/community/special_topic_management": "专题管理",
    "/community/plate_management": "版块管理",
    "/community/user_management": "用户管理",
    "/community/violation_management": "违规管理",
    "/community/material_management": "素材管理",
    "/community/template_management": "模板管理",
    "/superSuPro": "统一权限管理平台",
    "/superSuPro/jurisdiction": "运营权限管理",
    "/superSuPro/jurisdiction/resource": "模块管理",
    "/superSuPro/jurisdiction/admin": "账户管理",
    "/superSuPro/jurisdiction/role": "角色管理",
    "/superSuPro/jurisdiction/org": "组织机构管理",
    "/superSuPro/authorityJurisdiction": "经销商权限管理",
    "/superSuPro/authorityJurisdiction/superuser": "经销商授权管理",
    "/superSuPro/authorityJurisdiction/usercontrol": "经销商用户管理",
    "/authorityCenter": "app权限中心",
    "/authorityCenter/release": "灰度发布",
    "/authorityCenter/appAuthority": "APP权限管理",
    "/authorityCenter/carAuthority": "车辆权限",
    "/authorityCenter/userAuthority": "用户权限",
    "/operationSystem": "TSP运营管理平台",
    "/middlePlatform": "中台配置管理平台",
    "/authorityPlatform": "统一权限管理平台",
    "/cockpitPlatform": "座舱运营管理平台",
    "/appPlatform": "APP运营管理平台",
    "/labelManagement": "用户标签管理",
    "/labelManagement/labelManagement": "标签管理",
    "/labelManagement/userLabelManagement": "用户标签关系管理",
    "/labelManagement/mapSetting": "映射关系管理",
    "/labelSiteManagement": "标签站点管理",
    "/afterSalesTool/afterSalesVehicleInformation": "售后车辆数据查询",
    "/ownerCenter": "车主中心",
    "/ownerCenter/ownerManagement": "车主管理",
    "/ownerCenter/ownerBindingQuery": "车主车辆绑定查询",
    "/ownerCenter/ownerBindingChange": "车辆绑定变更记录",
    "/cockpitPlatform/xbox": "手机互联配置",
    "/xbox/config": "互联配置管理",
    "/xbox/featConfig": "互联功能配置管理",
    "/xbox/sdkConfig": "SDK版本配置管理",
    "/csaSystem": "CSA运营平台",
    "/csaSystem/bookingManagement": "预约管理",
    "/csaSystem/lotteryManagement": "奖券管理",
    "/csaSystem/deviceManagement": "设备管理",
    "/csaSystem/userManage": "用户管理",
    "/csaSystem/ugcManage": "UGC内容管理",
    "/csaSystem/queManage": "问卷管理",
    "/csaSystem/queManage/learningQue": "知识问答问卷",
    "/csaSystem/queManage/manMachine": "人机匹配问卷"
  },
  "SYSTEM_MSG": {
    "name": "站内消息",
    "sent": "发送的消息",
    "received": "接收的消息"
  }
}